import { LinkProps }               from 'react-router-dom';
import { Link as ReactRouterLink } from 'react-router-dom';
import globalModalStore            from '@widesk-ui/stores/globalModalStore';

const Link = (props: LinkProps & { linkSecondary?: boolean }) => {
	const { linkSecondary, ...linkProps } = props;
	return (
		<ReactRouterLink
			target={props.target}
			onClick={e => {
				globalModalStore.clear();

				props.onClick?.(e);
			}}
			{...linkProps}
			style={{
				...props.style,
				...(linkSecondary ? { color: 'var(--ant-color-text-description)', textDecoration: 'underline' } : {}),
			}}
		/>
	);
};

export default Link;
